// extracted by mini-css-extract-plugin
export default {"revert-filename-changes":"styles_revert-filename-changes__KutVL","export-icon":"styles_export-icon__74Sro","disabled":"styles_disabled__ogLHf"};